import { render } from "./PostComment.vue?vue&type=template&id=3a05dbc6"
import script from "./PostComment.vue?vue&type=script&lang=js"
export * from "./PostComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__